import { getUser } from '@/store/slices/user/selectors';
import { IWatermarkElement, WatermarkElementTypes } from '@/types/watermarks.types';
import { niceTime } from '@/utils/dates';
import { formatWatermarkDateTime } from './format-watermark-date';
import { store } from '@/store/main';

export const getTextForElement = (el: IWatermarkElement): string => {
  const email = getUser(store.getState())?.email;

  switch (el.type) {
    case WatermarkElementTypes.email:
      return email ?? '';
    case WatermarkElementTypes.date:
      return (
        el.settings.text?.value ||
        formatWatermarkDateTime(new Date(), null, Intl.DateTimeFormat().resolvedOptions().timeZone)
      );
    case WatermarkElementTypes.time:
      return niceTime(Date.now());
    case WatermarkElementTypes.custom:
      return el.settings.text?.value ?? '';
    default:
      return '';
  }
};
